import { useState } from "react";
import "./AddMovie.css";

const EMPTY = { title: "", description: "", posterURL: "", rating: "" };

export default function AddMovie({ onAdd }) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const errs = {};
    if (!form.title.trim()) errs.title = "Title is required";
    if (!form.description.trim()) errs.description = "Description is required";
    if (!form.posterURL.trim()) errs.posterURL = "Poster URL is required";
    const r = parseFloat(form.rating);
    if (isNaN(r) || r < 0 || r > 10) errs.rating = "Rating must be 0 – 10";
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    onAdd({ ...form, rating: parseFloat(form.rating) });
    setForm(EMPTY);
    setErrors({});
  };

  return (
    <div className="add-movie">
      <h2 className="add-movie__heading">Add a Title</h2>
      <form className="add-movie__form" onSubmit={handleSubmit} noValidate>
        <div className="field-row">
          {/* Title */}
          <div className={`field ${errors.title ? "field--error" : ""}`}>
            <label className="field__label">Title</label>
            <input
              className="field__input"
              name="title"
              placeholder="e.g. The Dark Knight"
              value={form.title}
              onChange={handleChange}
            />
            {errors.title && (
              <span className="field__error">{errors.title}</span>
            )}
          </div>

          {/* Rating */}
          <div
            className={`field field--sm ${errors.rating ? "field--error" : ""}`}
          >
            <label className="field__label">Rating (0–10)</label>
            <input
              className="field__input"
              name="rating"
              type="number"
              step="0.1"
              min="0"
              max="10"
              placeholder="8.5"
              value={form.rating}
              onChange={handleChange}
            />
            {errors.rating && (
              <span className="field__error">{errors.rating}</span>
            )}
          </div>
        </div>

        {/* Poster URL */}
        <div className={`field ${errors.posterURL ? "field--error" : ""}`}>
          <label className="field__label">Poster URL</label>
          <input
            className="field__input"
            name="posterURL"
            placeholder="https://…"
            value={form.posterURL}
            onChange={handleChange}
          />
          {errors.posterURL && (
            <span className="field__error">{errors.posterURL}</span>
          )}
        </div>

        {/* Description */}
        <div className={`field ${errors.description ? "field--error" : ""}`}>
          <label className="field__label">Description</label>
          <textarea
            className="field__input field__textarea"
            name="description"
            rows={3}
            placeholder="Short synopsis…"
            value={form.description}
            onChange={handleChange}
          />
          {errors.description && (
            <span className="field__error">{errors.description}</span>
          )}
        </div>

        {/* Preview + Submit */}
        <div className="add-movie__actions">
          {form.posterURL && (
            <img
              src={form.posterURL}
              alt="preview"
              className="add-movie__preview"
              onError={(e) => (e.target.style.display = "none")}
            />
          )}
          <button className="submit-btn" type="submit">
            Add to Collection
          </button>
        </div>
      </form>
    </div>
  );
}
